import { useMemo } from "react";
import {
  convertToTilteCase,
  defaultDateDisplay,
  formatCurrency,
} from "../../../../helpers";
import { useTable } from "react-table";

export const usePlatformCreditTable = ({ creditTransactions = {} }) => {
  const columns = useMemo(
    () => [
      {
        Header: "Created At",
        accessor: "created_at",
        Cell: ({ cell: { value } }) =>
          value ? defaultDateDisplay(value) : "N/A",
      },
      {
        Header: "Transaction Type",
        accessor: "transaction_type",
        Cell: ({ cell: { value } }) => (
          <span
            className={`${value === "CREDIT" ? "success--text" : "error--text"}`}
          >
            {convertToTilteCase(value)}
          </span>
        ),
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ cell: { value } }) => formatCurrency({ value }),
      },
      {
        Header: "Balance Before",
        accessor: "balance_before",
        Cell: ({ cell: { value } }) => (
          <span>
            {value || 0} <span className="gray--text">credit</span>
          </span>
        ),
      },
      {
        Header: "Balance After",
        accessor: "balance_after",
        Cell: ({ cell: { value } }) => (
          <span>
            {value || 0} <span className="gray--text">credit</span>
          </span>
        ),
      },
    ],
    [],
  );

  const instance = useTable({
    columns,
    data: creditTransactions || [],
  });

  return { instance };
};
